//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';
import { SampleGraphEmbed } from '../../components/demo/SampleGraphEmbed';

export const OrdersHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background">

      <Box background="url('/images/satin-1.jpg')" height="140px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
                        <PageHeader pad={{ top: '5px', bottom: '10px' }} 
                          title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>HPE Orders and Global Trade</Text>} 
                          subtitle={"Ensuring order velocity AND global compliance"}
                          style={{ color: 'white' }}
                          size='medium'/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">


          <Heading size="small" weight="bold" margin={{ top: 'large' }}>Coming soon...</Heading>

          <Box pad={{ bottom: 'medium'}}> 
            <SampleGraphEmbed />
          </Box>

      </PageContent>  

    </Page>
  );
};